import React from "react";
import "./ToastNotification.css";

export const ToastNotification = ({ data }) => {
    return (
        <div className="epac-toast-notification">
            {data.title && <div className="toast-title">{data.title}</div>}
            {data.content && <div className="toast-content">{data.content}</div>}
        </div>
    );
};
